import { render, staticRenderFns } from "./DossierTextBlockView.vue?vue&type=template&id=38867d21&scoped=true&"
import script from "./DossierTextBlockView.vue?vue&type=script&lang=ts&"
export * from "./DossierTextBlockView.vue?vue&type=script&lang=ts&"
import style0 from "./DossierTextBlockView.vue?vue&type=style&index=0&id=38867d21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38867d21",
  null
  
)

export default component.exports